/**
 * Domain-specific error types for the auth module
 */

export class AuthError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AuthError';
  }
}

export class InvalidCredentialsError extends AuthError {
  constructor() {
    super('Invalid username or password');
    this.name = 'InvalidCredentialsError';
  }
}

export class TokenVerificationError extends AuthError {
  constructor() {
    super('Invalid or expired token');
    this.name = 'TokenVerificationError';
  }
}

export class NetworkError extends AuthError {
  constructor() {
    super('Network error occurred');
    this.name = 'NetworkError';
  }
}

export class UnknownError extends AuthError {
  constructor(originalError?: Error) {
    super(originalError?.message || 'An unknown error occurred');
    this.name = 'UnknownError';
  }
}
